import {
  Box,
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { t } from 'i18next';

interface EditableTableProps {
  title: string;
  description: string;
  instructions: { value: string }[];
  setInstructions: (instructions: { value: string }[]) => void;
  isLoading: boolean;
  columnHeader?: string;
  onAddRow?: () => void;
}

const EditableTable = ({
  title,
  description,
  instructions,
  setInstructions,
  isLoading,
  columnHeader = 'Instruction',
  onAddRow,
}: EditableTableProps) => {
  const handleDeleteRow = (index: number) => {
    const newInstructions = instructions.filter((_, i) => i !== index);
    setInstructions(newInstructions);
  };

  const handleInstructionChange = (index: number, value: string) => {
    const newInstructions = [...instructions];
    newInstructions[index].value = value;
    setInstructions(newInstructions);
  };

  return (
    <Box sx={{
      marginBottom: { xs: 2, sm: 3 },
    }}>
      {/* Floating Paper Items */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        marginBottom: { xs: 2, sm: 3 },
      }}>
        {instructions.map((instruction, index) => (
          <Paper
            key={index}
            elevation={2}
            sx={{
              padding: 2,
              position: 'relative',
              backgroundColor: '#F8F8FB',
            }}
          >
            {/* Index and Delete Button Row */}
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 1,
            }}>
              <Typography variant="body2" color="text.secondary">
                #{index + 1}
              </Typography>
              <IconButton
                onClick={() => handleDeleteRow(index)}
                disabled={isLoading}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            
            {/* Text Field */}
            <TextField
              fullWidth
              variant="outlined"
              value={instruction.value}
              onChange={(e) =>
                handleInstructionChange(index, e.target.value)
              }
              placeholder={`${t('Enter')} ${columnHeader.toLowerCase()}`}
              disabled={isLoading}
              multiline
              minRows={2}
            />
          </Paper>
        ))}
        
        {instructions.length === 0 && (
          <Paper
            elevation={1}
            sx={{
              padding: 3,
              textAlign: 'center',
              color: 'text.secondary',
              backgroundColor: '#F8F8FB',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
              }}
            >
              {t(`No ${columnHeader === t('Task') ? 'tasks' : columnHeader === t('Description') ? 'descriptions' : 'instructions'} available`)}
            </Typography>
          </Paper>
        )}
      </Box>
    </Box>
  );
};

export default EditableTable;
